/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./new-dialog.vue?vue&type=template&id=074fdc40&scoped=true&"
import script from "./new-dialog.vue?vue&type=script&lang=js&"
export * from "./new-dialog.vue?vue&type=script&lang=js&"
import style0 from "./new-dialog.vue?vue&type=style&index=0&id=074fdc40&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074fdc40",
  null
  
)

export default component.exports